import type { JSX } from 'react';
import type { Placement } from 'react-aria';
import { Message } from '@gonfalon/messages/Message';
import { Menu, MenuItem, MenuTrigger, Popover, Text } from '@launchpad-ui/components';

import styles from './FilterSelectionPopover.module.css';

interface FilterSelectionPopoverProps {
  children: JSX.Element;
  onSelectContextKind: () => void;
  onSelectEventProperty: () => void;
  placement?: Placement;
}

export const FilterSelectionPopover: React.FC<FilterSelectionPopoverProps> = ({
  children,
  onSelectContextKind,
  onSelectEventProperty,
  placement = 'bottom left',
}) => (
  <MenuTrigger>
    {children}
    <Popover className={styles.filterPopover} placement={placement}>
      <Menu>
        <MenuItem onAction={onSelectContextKind}>
          <Text slot="label">
            <Message id="metrics.eventFilters.contextAttribute" />
          </Text>
          <Text slot="description">
            <Message
              id="metrics.eventFilters.contextAttributeHelp"
              values={{ code: (chunks) => <code>{chunks}</code> }}
            />
          </Text>
        </MenuItem>
        <MenuItem onAction={onSelectEventProperty}>
          <Text slot="label">
            <Message id="metrics.eventFilters.eventProperty" />
          </Text>
          <Text slot="description">
            <Message id="metrics.eventFilters.eventPropertyHelp" values={{ code: (chunks) => <code>{chunks}</code> }} />
          </Text>
        </MenuItem>
      </Menu>
    </Popover>
  </MenuTrigger>
);
